export enum RefereeCoachGrade {
  ungraded = 0,
  grade1 = 1,
  grade2 = 2,
  grade3 = 3,
  grade4 = 4,
  grade5 = 5,
}

export namespace RefereeCoachGrade {
  export function all(): RefereeCoachGrade[] {
    return [
      RefereeCoachGrade.ungraded,
      RefereeCoachGrade.grade1,
      RefereeCoachGrade.grade2,
      RefereeCoachGrade.grade3,
      RefereeCoachGrade.grade4,
      RefereeCoachGrade.grade5,
    ];
  }

  export function toShortString(gr: RefereeCoachGrade): string {
    switch (gr) {
      case RefereeCoachGrade.ungraded:
        return "UG";
      case RefereeCoachGrade.grade1:
        return "G1";
      case RefereeCoachGrade.grade2:
        return "G2";
      case RefereeCoachGrade.grade3:
        return "G3";
      case RefereeCoachGrade.grade4:
        return "G4";
      case RefereeCoachGrade.grade5:
        return "G5";
      default:
        return "-";
    }
  }
}
